import { theme } from 'components/Theme/main';
import { mapAvailabilityData } from 'connectors/availability/Availability';
import { mapProductPriceData, mapProductPricesData } from 'connectors/price/Prices';
import { ProductColorVariantFragmentApi, SimpleProductFragmentApi } from 'graphql/generated';
import { formatProductNameWithNonBreakingSpaces } from 'helpers/formaters/formatText';
import { ColorVariantType, SimpleProductType } from 'types/product';

export const mapSimpleProductApiData = (
    simpleProductApiData: SimpleProductFragmentApi,
    currencyCode: string,
): SimpleProductType => {
    return {
        ...simpleProductApiData,
        fullName: formatProductNameWithNonBreakingSpaces(simpleProductApiData.fullName),
        price: mapProductPriceData(simpleProductApiData.price, currencyCode),
        prices: mapProductPricesData(simpleProductApiData.prices, currencyCode),
        mainImage: simpleProductApiData.mainImage,
        unitName: simpleProductApiData.unit.name,
        categoryNames: simpleProductApiData.categories.map((category) => category.name),
        availability: mapAvailabilityData(simpleProductApiData.availability),
        colorVariants: mapColorVariants(simpleProductApiData.colorVariants),
        currentColorVariant:
            'currentColorVariant' in simpleProductApiData
                ? mapColorVariant(simpleProductApiData.currentColorVariant)
                : null,
        b2bMinimumProductOrder: simpleProductApiData.b2bMinimumProductOrder,
    };
};

const mapColorVariant = (variant: ProductColorVariantFragmentApi): ColorVariantType => ({
    ...variant,
    name: formatProductNameWithNonBreakingSpaces(variant.name),
    value: variant.value ?? theme.color.gray,
    parameterValueImages: variant.parameterValueImages ?? null,
});

const mapColorVariants = (colorVariants: SimpleProductFragmentApi['colorVariants']): ColorVariantType[] => {
    const mappedData = [];

    for (const variant of colorVariants) {
        if (variant.value !== null) {
            mappedData.push(mapColorVariant(variant));
        }
    }

    return mappedData;
};
